import React from 'react'
import PropTypes from 'prop-types'
import { CloseIcon } from '@ow/icons'
import StyleIcon from '../styled/icon'
import StyledDefaultContent from '../styled/default-content'
import Icon from './Icon'

const DefaultContent = ({
  title,
  description,
  onClose,
  type,
  textColor,
  children,
}) => {
  return (
    <StyledDefaultContent>
      <div>
        <Icon type={type} textColor={textColor} />
        {title && <strong>{title}. </strong>}
        {description || children}
      </div>
      <StyleIcon onClick={(e) => onClose(e)}>
        <CloseIcon width={18} height={18} />
      </StyleIcon>
    </StyledDefaultContent>
  )
}

DefaultContent.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onClose: PropTypes.func,
  textColor: PropTypes.string,
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.shape,
  ]),
}

DefaultContent.defaultProps = {
  title: undefined,
  description: undefined,
  textColor: undefined,
  type: 'info',
  onClose: undefined,
  children: undefined,
}
export default DefaultContent
